import { render, staticRenderFns } from "./PublicProfileLayout.vue?vue&type=template&id=c8565eac"
import script from "./PublicProfileLayout.vue?vue&type=script&lang=js"
export * from "./PublicProfileLayout.vue?vue&type=script&lang=js"
import style0 from "./PublicProfileLayout.vue?vue&type=style&index=0&id=c8565eac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports